<template>
  <v-container class="booking-summary-container" fluid>
    <!-- ========================================== -->
    <!-- BEAUTIFUL PARTNER RECEIPT HEADER           -->
    <!-- ========================================== -->
    <v-layout row wrap>
      <v-flex lg12>
        <v-container fluid class="pa-2">
          <div class="booking-summary-header">
            <h3 class="knockout-header summary-title">
              PARTNER RECEIPT
              <span v-if="singleBooking && singleBooking.booking_ref_code" class="knockout-header summary-title">
                - REF: {{ singleBooking.booking_ref_code }}
              </span>
            </h3>
            <div class="summary-header-decoration"></div>
          </div>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- ========================================== -->
    <!-- MAIN CONTENT: Booking & Client Details     -->
    <!-- ========================================== -->
    <v-layout row wrap>
      <v-flex lg6 md6 xs12>
        <v-card flat class="beautiful-info-card mb-4">
          <div class="info-card-header">
            <v-icon left dark small>mdi-ticket</v-icon>
            BOOKING REFERENCE
          </div>
          <div class="info-card-body">
            <div class="ref-code">{{ singleBooking.booking_ref_code }}</div>
            <div class="info-row"><span class="info-label">Booking by:</span> {{ singleBooking.booking_done_by }}</div>
            <div class="info-row"><span class="info-label">Created at:</span> {{ formated_date_time(singleBooking.created_at) }}</div>
            <div class="info-row"><span class="info-label">Check In:</span> {{ formated_date(singleBooking.booking_check_in_date) }}</div>
            <div class="info-row"><span class="info-label">Check Out:</span> {{ formated_date(singleBooking.booking_check_out_date) }}</div>
            <div class="info-row"><span class="info-label">Payment Status:</span> {{ singleBooking.booking_payment_status }}</div>
            <div v-if="singleBooking.partner_booking_ref" class="info-row"><span class="info-label">Partner Booking Ref:</span> {{ singleBooking.partner_booking_ref }}</div>
            <div v-if="singleBooking.paid_by" class="info-row"><span class="info-label">Payment Detail:</span> {{ singleBooking.paid_by }}</div>
          </div>
        </v-card>
      </v-flex>
      <v-flex lg6 md6 xs12>
        <v-card flat class="beautiful-info-card mb-4">
          <div class="info-card-header">
            <v-icon left dark small>mdi-account-box</v-icon>
            CLIENT DETAILS
          </div>
          <div class="info-card-body">
            <div class="info-row"><span class="info-label">Guest:</span> {{ singleBooking.booking_done_by }}</div>
            <div class="info-row"><span class="info-label">Phone:</span> {{ singleBooking.booking_details.phone_number }}</div>
            <div class="info-row"><span class="info-label">Email:</span> {{ singleBooking.booking_details.email_address }}</div>
            <div class="info-row"><span class="info-label">Destination:</span> {{ singleBooking.destination }}</div>
            <div class="info-row"><span class="info-label">Address:</span> {{ singleBooking.booking_details.address }}</div>
            <div class="info-row"><span class="info-label">KRA PIN:</span> {{ singleBooking.booking_details.kra_pin_number }}</div>
            <div class="info-row"><span class="info-label">Client Note:</span> {{ singleBooking.booking_details.additional_note }}</div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ========================================== -->
    <!-- FEE TABLES                                 -->
    <!-- ========================================== -->
    <v-card flat class="beautiful-info-card mb-4">
      <div class="info-card-header">
        <v-icon left dark small>mdi-cash</v-icon>
        FEE BREAKDOWN
      </div>
      <div class="info-card-body">

        <!-- Conservancy Fees -->
        <div class="table-responsive m-t">
          <h4 class="earth-color">CONSERVANCY FEES</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <td><b>Residency</b></td>
                <td><b>Guests</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(guest, key) in singleBooking.guests" v-if="guest.payment_guests > 0" :key="key">
                <td>{{ guest.payment_person }}</td>
                <td>{{ guest.payment_guests }}</td>
                <td>{{ guest.payment_person_currency }} {{ $roundOff(guest.payment_guests * guest.payment_person_amount * guest.no_of_nights * ((100 - guest.payment_person_discount) / 100)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Vehicle Fees -->
        <div class="table-responsive m-t">
          <h4 class="earth-color">CONSERVANCY VEHICLE FEES</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <td><b>Vehicle Type</b></td>
                <td><b>No. of Vehicles</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vehicle, key) in singleBooking.vehicles" v-if="vehicle.vehicles > 0" :key="key">
                <td>{{ vehicle.vehicle_charge_category }}</td>
                <td>{{ vehicle.vehicles }}</td>
                <td>{{ singleBooking.currency }} {{ $roundOff(convert1(vehicle.vehicle_charge_cost_currency, vehicle.vehicles * vehicle.vehicle_charge_category_cost * vehicle.vehicle_no_of_nights * ((100 - vehicle.discount) / 100)).amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Accommodation -->
        <div class="table-responsive m-t" v-if="singleBooking.facility_bookings.length > 0">
          <h4 class="earth-color">CONSERVANCY ACCOMMODATION</h4>
          <table v-if="singleBooking.partner_id !== ''" class="table table-striped">
            <thead>
              <tr>
                <td><b>Name</b></td>
                <td><b>Guests</b></td>
                <td><b>Date In</b></td>
                <td><b>Date Out</b></td>
                <td><b>Amount Before Discount</b></td>
                <td><b>Agent Discount</b></td>
                <td><b>Agent Discount Amount</b></td>
                <td><b>Total Discount</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(facility, key) in singleBooking.facility_bookings" :key="key">
                <td>{{ facility.facility_name }}</td>
                <td>{{ facility.facility_booking_guests }}</td>
                <td>{{ formated_date(facility.facility_booking_check_in_date) }}</td>
                <td>{{ formated_date(facility.facility_booking_check_out_date) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_fixed_cost_before_discount) }}</td>
                <td>{{ facility.facility_booking_special_discount }} %</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_special_discount_amount) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_discount_ui) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_total_cost) }}</td>
              </tr>
            </tbody>
          </table>
          <table v-else class="table table-striped">
            <thead>
              <tr>
                <td><b>Name</b></td>
                <td><b>Guests</b></td>
                <td><b>Date In</b></td>
                <td><b>Date Out</b></td>
                <td><b>Amount Before Discount</b></td>
                <td><b>Total Discount</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(facility, key) in singleBooking.facility_bookings" :key="key">
                <td>{{ facility.facility_name }}</td>
                <td>{{ facility.facility_booking_guests }}</td>
                <td>{{ formated_date(facility.facility_booking_check_in_date) }}</td>
                <td>{{ formated_date(facility.facility_booking_check_out_date) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_fixed_cost_before_discount) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_discount_ui) }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_total_cost) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- External Accommodation -->
        <div class="table-responsive m-t" v-if="singleBooking.external_facility_bookings.length > 0">
          <h4 class="earth-color">OL PEJETA ESCAPES ACCOMMODATION</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <td><b>Name</b></td>
                <td><b>Price Parameter</b></td>
                <td><b>Duration</b></td>
                <td><b>No of Nights</b></td>
                <td><b>Amount</b></td>
                <td><b>Discount %</b></td>
                <td><b>Discount</b></td>
                <td><b>Supplement Price</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(facility, key) in singleBooking.external_facility_bookings" :key="key">
                <td>{{ facility.facility_name }}</td>
                <td>{{ facility.pricing_parameter.parameter_name }}</td>
                <td>{{ formated_date(facility.facility_booking_check_in_date) }} - {{ formated_date(facility.facility_booking_check_out_date) }}</td>
                <td>{{ facility.facility_no_of_nights }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_total_cost) }}</td>
                <td>{{ facility.facility_booking_discount_percentage }}</td>
                <td>{{ facility.facility_booking_currency }} {{ $roundOff(facility.facility_booking_discount) }}</td>
                <td><span v-for="(supp, key) in facility.pricing_parameter.supplement_prices" :key="key">{{ supp.supplement_price_name }}({{ facility.facility_booking_currency }} {{ supp.supplement_fixed_rate }}) </span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Activities -->
        <div class="table-responsive m-t" v-if="singleBooking.inventory_bookings.length > 0">
          <h4 class="earth-color">CONSERVANCY ACTIVITIES</h4>
          <table v-if="singleBooking.partner_id !== ''" class="table table-striped">
            <thead>
              <tr>
                <td><b>Name</b></td>
                <td><b>Guests</b></td>
                <td><b>Date</b></td>
                <td><b>Agent Discount</b></td>
                <td><b>Agent Discount Amount</b></td>
                <td><b>Discount</b></td>
                <td><b>Discount Amount</b></td>
                <td><b>Total Discount</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(activity, key) in singleBooking.inventory_bookings" :key="key">
                <td>{{ activity.inventory_name }}</td>
                <td>{{ activity.inventory_booking_guests }}</td>
                <td>{{ formated_date(activity.inventory_booking_date) }}</td>
                <td>{{ activity.agent_discount }}%</td>
                <td>{{ activity.inventory_booking_currency }} {{ activity.agent_discount_amount }}</td>
                <td>{{ activity.inventory_booking_discount_percentage }}%</td>
                <td>{{ activity.inventory_booking_currency }} {{ activity.discount_amount }}</td>
                <td>{{ activity.inventory_booking_currency }} {{ activity.inventory_booking_total_discount }}</td>
                <td>{{ activity.inventory_booking_currency }} {{ $roundOff(activity.inventory_booking_total_cost) }}</td>
              </tr>
            </tbody>
          </table>
          <table v-else class="table table-striped">
            <thead>
              <tr>
                <td><b>Name</b></td>
                <td><b>Guests</b></td>
                <td><b>Date</b></td>
                <td><b>Discount</b></td>
                <td><b>Discount Amount</b></td>
                <td><b>Amount</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(activity, key) in singleBooking.inventory_bookings" :key="key">
                <td>{{ activity.inventory_name }}</td>
                <td>{{ activity.inventory_booking_guests }}</td>
                <td>{{ formated_date(activity.inventory_booking_date) }}</td>
                <td>{{ activity.inventory_booking_discount_percentage }}%</td>
                <td>{{ activity.inventory_booking_currency }} {{ activity.inventory_booking_total_discount }}</td>
                <td>{{ activity.inventory_booking_currency }} {{ $roundOff(activity.inventory_booking_total_cost) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Total -->
        <div class="row m-t">
          <div class="col-md-4 col-md-offset-8">
            <table class="table table-striped text-right">
              <tbody>
                <tr>
                  <td><div style="font-size: 20px; font-weight: bold;">TOTAL :</div></td>
                  <td><div style="font-size: 30px; font-weight: bold;">{{ singleBooking.currency }} {{ $roundOff(singleBooking.total_cost) }}</div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </v-card>

    <!-- ========================================== -->
    <!-- DIALOGS (unchanged)                        -->
    <!-- ========================================== -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h4 class="earth-color">ADD EMAILS</h4>
          <hr />
        </v-card-title>
        <v-card-text>
          <v-container class="booking-summary-container" grid-list-md>
            <v-flex xs12>
              <v-text-field label="Email*" required :value="singleBooking.booking_details.email_address" v-model="emails.email" placeholder="john@apple.com, obts@olpejetaconservancy.org" outline autocapitalize="none" oninput="this.value=this.value.toLowerCase()"></v-text-field>
              <p class="text-danger">* Separate the emails with a comma</p>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="green darken-1" flat @click="sendMail()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========================================== -->
    <!-- FIXED FOOTER WITH ACTION BUTTONS           -->
    <!-- ========================================== -->
    <v-footer app fixed height="auto" class="action-footer">
      <v-container fluid>
        <v-layout row wrap align-center justify-center>
          <v-flex shrink>
            <v-btn depressed class="earth-color arial-text print-badge grey-badge black--text mx-1" @click="dialog = true; populateEmailValue()">
              SEND EMAIL
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn depressed class="earth-color arial-text print-badge grey-badge black--text mx-1" :loading="this.$store.state.LoadingStore.loading" @click="printReceipt()">
              PRINT
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <router-link :to="{ name: 'NewBooking' }" v-if="this.institutionId === 'N/A'">
              <v-btn depressed color="primary" class="mx-1 arial-text">MAKE NEW BOOKING</v-btn>
            </router-link>
            <router-link :to="{ name: 'NewPartnerBooking' }" v-if="this.institutionId !== 'N/A'">
              <v-btn depressed color="primary" class="mx-1 arial-text">MAKE NEW BOOKING</v-btn>
            </router-link>
          </v-flex>
          <v-flex shrink>
            <router-link :to="{ name: 'GatePayment', params: { booking_id: this.$route.params.booking_id } }" v-if="this.institutionId === 'N/A' && singleBooking.booking_payment_balance > 0">
              <v-btn depressed color="info" class="mx-1 arial-text">ADD PAYMENT</v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>

  </v-container>
</template>

<script>
  import router from "../../../router";
  import axios from "axios";

  export default {
    data() {
      return {
        dialog: false,
        canceling: false,
        institutionId: JSON.parse(localStorage.getItem("unem")).instiution_id,
        emails: {
          email: ""
        }
      };
    },
    computed: {
      singleBooking() {
        return this.$store.state.BookingStore.booking;
      }
    },
    methods: {
      populateEmailValue() {
        this.emails.email = this.singleBooking.booking_details.email_address;
      },
      sendMail() {
        let emails = this.emails.email;
        let emailArr = emails.split(",");
        let receipents = [];
        for (var i = 0; i < emailArr.length; i++) {
          emailArr[i] = emailArr[i].replace(/^\s*/, "").replace(/\s*$/, "");
          receipents.push(emailArr[i]);
        }
        let data_ = {
          booking_id: this.$route.params.booking_id,
          email: receipents,
          session_id: localStorage.getItem("lkjhgfdsa")
        };
        this.$store.dispatch("send_email", data_);
        this.dialog = false;
      },
      printReceipt() {
        var data = {
          booking_id: this.$route.params.booking_id,
          session_id: localStorage.getItem("lkjhgfdsa")
        };
        this.$store.dispatch("print_receipt_new", data);
      }
    },
    created() {
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
    }
  };
</script>

<style scoped>
  /* ---- Copied from Booking.vue styles ---- */
  .booking-summary-container {
    zoom: 0.9;
    --scale-factor: 0.9;
    font-size: calc(1em * var(--scale-factor));
  }

  /* ---- BEAUTIFUL BOOKING SUMMARY HEADER ---- */
  .booking-summary-header {
    background: linear-gradient(145deg, #2d5016, #4a7c2b);
    border-radius: 16px;
    padding: 24px 32px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(46, 80, 20, 0.25);
    margin-bottom: 8px;
  }

    .booking-summary-header::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -20%;
      width: 300px;
      height: 300px;
      background: rgba(255, 255, 255, 0.06);
      border-radius: 50%;
      pointer-events: none;
    }

    .booking-summary-header::after {
      content: '';
      position: absolute;
      bottom: -60%;
      left: -10%;
      width: 200px;
      height: 200px;
      background: rgba(255, 255, 255, 0.04);
      border-radius: 50%;
      pointer-events: none;
    }

  .summary-title {
    color: #ffffff !important;
    position: relative;
    z-index: 2;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  .summary-header-decoration {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f5b342, #f1c40f, #f5b342);
    z-index: 2;
  }

  /* ---- BEAUTIFUL INFO CARDS ---- */
  .beautiful-info-card {
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid rgba(116, 165, 51, 0.12);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
  }

    .beautiful-info-card:hover {
      box-shadow: 0 8px 30px rgba(116, 165, 51, 0.08);
      border-color: rgba(116, 165, 51, 0.20);
    }

  .info-card-header {
    background: linear-gradient(145deg, #2d5016, #3d6b22);
    padding: 12px 20px;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.8rem;
    letter-spacing: 1.2px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

    .info-card-header .v-icon {
      font-size: 18px;
    }

  .info-card-body {
    padding: 16px 20px;
    background: #fafcf8;
  }

  .ref-code {
    font-size: 1.4rem;
    font-weight: 700;
    color: #2d5016;
    letter-spacing: 1px;
    margin-bottom: 8px;
    padding: 4px 0;
    border-bottom: 2px solid rgba(116, 165, 51, 0.15);
  }

  .info-row {
    font-size: 0.8rem;
    padding: 2px 0;
    color: #3d4a2e;
  }

  .info-label {
    font-weight: 600;
    color: #2d5016;
    margin-right: 4px;
  }

  /* Table styling */
  .table-responsive {
    overflow-x: auto;
    margin-top: 12px;
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    border-collapse: collapse;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.02);
  }

  .table td, .table th {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }

  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
  }

  .earth-color {
    color: #2d5016;
  }

  .m-t {
    margin-top: 16px;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .col-md-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  .col-md-offset-8 {
    margin-left: 66.666667%;
  }

  .text-right {
    text-align: right;
  }

  /* ---- ACTION FOOTER ---- */
  .action-footer {
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(8px);
    border-top: 1px solid rgba(116, 165, 51, 0.15);
    z-index: 10;
    padding: 8px 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.04);
  }

    .action-footer .v-btn {
      min-width: 80px;
      margin: 4px 4px;
      border-radius: 30px;
      font-weight: 500;
      letter-spacing: 0.5px;
      transition: all 0.2s ease;
    }

      .action-footer .v-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      }

  .print-badge {
    padding: 8px 16px;
    border-radius: 4px;
  }

  .grey-badge {
    background-color: #e0e0e0;
    color: #333;
  }

  .arial-text {
    font-family: Arial, sans-serif;
  }

  .knockout-header {
    font-family: 'Arial Black', sans-serif;
  }

  /* Responsive */
  @media (max-width: 960px) {
    .booking-summary-header {
      padding: 16px 20px;
    }

    .summary-title {
      font-size: 1.2rem;
    }

    .info-card-body {
      padding: 12px 16px;
    }

    .ref-code {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 600px) {
    .booking-summary-header {
      padding: 12px 16px;
      border-radius: 12px;
    }

    .summary-title {
      font-size: 1rem;
    }

    .info-card-body {
      padding: 10px 12px;
    }

    .ref-code {
      font-size: 0.95rem;
    }

    .info-row {
      font-size: 0.72rem;
    }
  }
</style>
